---
title: Utility
description: "A utility device: a gain, a pan, a width, a mono switch and a phase invert, a panel without a display, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-utility" />

Sets the level and the stereo image of a signal. It has no display, so its panel is only as tall as its controls. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="utility" kind="device" />

## Controls

<DeviceControls device="utility">
<Control id="gainDb">The level of the signal.</Control>
<Control id="pan">Moves the signal between the left and the right.</Control>
<Control id="width">The width of the stereo image. 0 is mono, 100 % is the input as it is and 200 % is twice as wide.</Control>
<Control id="mono">Sums the two channels to one.</Control>
<Control id="invert">Flips the phase of the signal.</Control>
</DeviceControls>

## Panel

The panel is the controls and nothing else. `utilitySettings(state)` gives the numbers that go on the nodes.

<DeviceUsage name="utility" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The signal is split into mid and side, and the width scales the side. A mono input is spread to both sides first. Off, the signal passes unchanged.
